/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import adminIcon from '../../../assets/images/group-admin.svg';
import actionIcon from '../../../assets/images/manage_accounts.svg';
import utils from '../../../utils/utils';

const AgencyContactsList = ({ contacts, searchFilter, hasContactsEditPermission, onEditContact }) => {
	const rowClass = (rowData) => (!rowData.is_portal_enabled ? 'inactive' : '');

	const nameTemplate = (item) => (
		<div className="d-flex">
			<div className="flex-one">{item.name}</div>
			{item.is_admin && <img src={adminIcon} alt="Group admin" />}
		</div>
	);

	const phoneNumberTemplate = (data) => utils.formatPhoneNumber(data.phone_number || '');
	const statusTemplate = (data) => (data.is_portal_enabled ? 'Enabled' : 'Disabled');
	const statusBodyTemplate = (data) => {
		if (!data.is_portal_enabled) {
			return <div className="warning">Disabled</div>;
		}
		return 'Enabled';
	};

	const actionsTemplate = (data) => (
		<OverlayTrigger
			placement="bottom"
			overlay={
				<Tooltip style={{ fontSize: '1.6rem' }}>
					<div style={{ padding: '0.5rem' }}>Manage profile</div>
				</Tooltip>
			}
		>
			<img src={actionIcon} alt="Manage profile" className="edit-contact-icon" onClick={() => onEditContact(data)} />
		</OverlayTrigger>
	);

	return (
		<div className="datatable-wrapper">
			<DataTable
				value={contacts}
				scrollable
				scrollHeight="flex"
				sortMode="multiple"
				tableStyle={{ minWidth: '100rem' }}
				stripedRows
				cellClassName="table-cell"
				rowClassName={rowClass}
				filters={searchFilter}
			>
				<Column field="name" header="Name" style={{ width: '20%' }} sortable body={nameTemplate} />
				<Column field={statusTemplate} header="Status" style={{ width: '12%' }} sortable body={statusBodyTemplate} />
				<Column field="email" header="Email" style={{ width: '20%' }} sortable />
				<Column
					field={phoneNumberTemplate}
					header="Phone"
					style={{ width: '10%' }}
					sortable
					body={phoneNumberTemplate}
				/>
				<Column field="phone_extension_number" header="Ext" style={{ width: '7%' }} sortable />
				{hasContactsEditPermission && (
					<Column field="actions" header="Actions" style={{ width: '12%' }} body={actionsTemplate} />
				)}
			</DataTable>
		</div>
	);
};

export default AgencyContactsList;
